import { Box } from "@mui/material";
import AiAskBarHomeComposerActions from "./AiAskBarHomeComposerActions";
import AiAskBarHomeRightAgentSelect from "./AiAskBarHomeRightAgentSelect";
import AiAskBarRightActionsDictating from "./AiAskBarRightActionsDictating";
import styles from "./index.module.scss";

export default function AiAskBarHomeRightActions({
  vm,
  actions,
  sendDisabled,
  onVoiceToggle,
  voiceActive,
  model,
  onModelChange,
  landing = false,
  showModelSelect = true,
}) {
  if (vm.isDictating) {
    return (
      <Box className={styles.rightActions}>
        <AiAskBarRightActionsDictating
          dictationCancelRef={vm.dictationCancelRef}
          handleDictationConfirm={actions.handleDictationConfirm}
          handleDictationCancel={actions.handleDictationCancel}
        />
      </Box>
    );
  }

  return (
    <Box className={styles.rightActions}>
      {showModelSelect ? (
        <AiAskBarHomeRightAgentSelect
          value={model}
          onChange={onModelChange}
          landing={landing}
        />
      ) : null}
      <AiAskBarHomeComposerActions
        vm={vm}
        actions={actions}
        sendDisabled={sendDisabled}
        onVoiceToggle={onVoiceToggle}
        voiceActive={voiceActive}
        landing={landing}
      />
    </Box>
  );
}
